import './styles.scss'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import Tracker from './Tracker'
import TrackItResult from './TrackItResult'

const TrackIt = () => {
  const { state } = useLocation()
  const [trackItResult, setTrackItResult] = useState(state?.result || null)

  return (
    <div className="track-it">
      <div className="track-it__top">
        <h1>Track your Package</h1>
      </div>

      <div className="track-it__content">
        {!trackItResult ? (
          <Tracker setTrackItResult={setTrackItResult} />
        ) : (
          <TrackItResult trackItResult={trackItResult} />
        )}
      </div>
    </div>
  )
}

export default TrackIt
